
import Cookies from 'js-cookie';
// Cookies.defaults = {
//   path: '/',
//   secure: true
// };
export default Cookies;